import React, { Component } from 'react';
import '../../Asset/Css/Site.css';
import axios from 'axios';
import { Link } from 'react-router-dom'
import queryString from 'query-string';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import global from '../global';
import moment from 'moment';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import { Layout } from '../Layout';
import Spinner from '../Spinner';
import { config } from '../../Constants';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';

export class AddEditBeneficiary extends Component {
    displayName = AddEditBeneficiary.name

    constructor(props) {
        super(props);
        this.state = {
            beneficiaryID: 0,
            userName: '',
            emailIDOld: '',
            beneficiaryName: '',
            PAN: '',
            DPID: '',
            DOB: '',
            remitterName: '',
            PAN: '',
            EmailId: '',
            formErrors: '',
            remitterID: 0,
            RemitterCode: '',
            token: '',
            flag: '',
            module: '',
            profile: 'none',
            beneficiary: 'none',
            loading: false,
            url: '',
            Title: 'Assignment Creation',
            ButtonText: 'CREATE',
            IsDisable: false,
        };

        this.initialState = this.state;
        this.state.loading = false;
        const parsed = queryString.parse(window.location.search);
        this.state.beneficiaryID = window.atob(parsed['bD']);
        this.state.module = parsed['module'];
        var ReqType = parsed['Type'] == undefined ? 'A' : window.atob(parsed['Type']);

        if (ReqType == 'E') {
            this.state.Title = 'Modify Shareholder Details';
            this.state.ButtonText = 'UPDATE';
            this.state.IsDisable = false;
        }
        else {
            this.state.Title = 'View Shareholder Details';
            this.state.ButtonText = 'VIEW';
            this.state.IsDisable = true;
        }

        //axios.get(global.UserManagement.GetSessionDetailsAPI)
        //    .then(response => {
        //        if (response.data.Status) {
        //            this.setState({
        //                RemitterCode: response.data.RemitterCode,
        //                token: response.data.JwtToken,
        //                url: config.url.Web_URL + '/' + response.data.RemitterCode
        //            });
        //        } else {
        //            window.location.href = config.url.Web_URL + `/Error/404`;
        //            return;
        //        }
        //    })
        //    .catch(error => {
        //        console.log(error);
        //    });


        if (this.state.module == 'UP') {
            this.state.profile = 'block'
        } else {
            this.state.beneficiary = 'block'
        }

        if (this.state.beneficiaryID > 0) {

            axios.get(global.Beneficiary.GetIdWiseProfileAPI + this.state.beneficiaryID,
                { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {
                    if (response.data.status) {
                        this.setState({
                            emailIDOld: response.data.beneficiaryDetails[0]["EmailID"],
                            beneficiaryID: response.data.beneficiaryDetails[0]["BeneficiaryID"],
                            beneficiaryName: response.data.beneficiaryDetails[0]["BeneficiaryName"],
                            remitterName: response.data.beneficiaryDetails[0]["RemitterName"],
                            PAN: response.data.beneficiaryDetails[0]["PAN"],
                            DPID: response.data.beneficiaryDetails[0]["DPID"],
                            EmailId: response.data.beneficiaryDetails[0]["EmailID"],
                            DOB: moment(response.data.beneficiaryDetails[0]["DOB"]).format('YYYY-MM-DD') === null ? " " : moment(response.data.beneficiaryDetails[0]["DOB"]).format('YYYY-MM-DD')

                        })
                    }
                })
                .catch(error => {
                    console.log(error);
                });

        }
        console.log(this.state.url);

    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = this.state.url + `/Nexdigm/Shareholder-Details`;
    }

    handleFormValidation = (e) => {

        const { beneficiaryName, DPID, DOB, PAN } = this.state;
        let formErrors = {};
        let formIsValid = true;

        this.setState({ formErrors: formErrors });
        const { name, value } = e.target;
        this.setState({ [name]: value });
        return formIsValid;

    }

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.state.EmailId == "" || this.state.EmailId == null) {
            this.showNoti("Notification", "Email ID is required", "danger");
            return;
        }

        var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

        if (!pattern.test(this.state.EmailId)) {
            this.showNoti("Notification", "Email ID is Invalid", "danger");
            return;
        }

        this.setState({ loading: true });
       
        this.state.beneficiaryID = parseInt(this.state.beneficiaryID);
        this.state.DOB = "1990-01-01";
        const demoUserProfile = this.state;

        axios.post(global.Beneficiary.IBeneficiaryAPI, demoUserProfile,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
            .then(json => {
                if (json.data.result) {

                    this.setState({ loading: false });
                    this.showNoti("Notification", "Details Updated Successfully", "success");

                    window.location.href = this.state.url +`/Nexdigm/Shareholder-Details`;

                }
                else {
                    this.setState({ loading: false });
                    this.showNoti("Notification", json.data.message, "danger");
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                console.log(error);
            });

    }


    render() {
        if (this.state.loading) return <Spinner />;

        let content = Layout.RenderNavMenu()
        const { beneficiaryNameErr, DPIDErr, DOBErr, PANErr } = this.state.formErrors;
        return (
            <div>
                <ReactNotification />
                {content}
                <div className="Nexdigm" style={{ display: this.state.beneficiary }}>
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.url + "/Dashboard?UT=" + window.btoa(this.state.RemitterCode.toUpperCase() == "NEXDIGM" ? "A" : "U")} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a href={this.state.url + "/Shareholder-Details"} className="text-white">Shareholder Details</a></li>
                        <li><a className="text-white">View Shareholder Details</a></li>
                    </ol>
                </div>
                <div className="Nexdigm" style={{ display: this.state.profile }}>
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.url + "/Dashboard?UT=" + window.btoa(this.state.RemitterCode.toUpperCase() == "NEXDIGM" ? "A" : "U")} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a href={this.state.url + "/Modify-Shareholder"} className="text-white">{this.state.Title}</a></li>
                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title">{this.state.Title}</h4>
                            <Row>
                                <Col md={6}>
                                    <label>Beneficiary Name</label>
                                    <FormControl type="text" name="beneficiaryName" key="txtBeneficiaryName" className="m-t-10"
                                        value={this.state.beneficiaryName}
                                        onChange={this.handleFormValidation} disabled />
                                </Col>
                                <Col md={6}>
                                    <label>Email</label>
                                    <FormControl type="text" name="EmailId" key="txtEmailId" className="m-t-10"
                                        value={this.state.EmailId}
                                        onChange={this.handleFormValidation}
                                        disabled={this.state.IsDisable} />
                                </Col>
                                <Col md={6} className="m-t-10">
                                    <label>DP ID</label> 
                                    <FormControl type="text" name="DPID" key="txtDPID" className="m-t-10"
                                        value={this.state.DPID}
                                        onChange={this.handleFormValidation} disabled />
                                    
                                </Col>

                                <Col md={6} className="m-t-10">
                                    <label>PAN</label>
                                    <FormControl type="text" name="PAN" key="txtPAN" className="m-t-10"
                                        value={this.state.PAN}
                                        onChange={this.handleFormValidation} disabled />
                                    
                                </Col>

                                <Col md={6} className="m-t-10">
                                    <label>Remitter</label>
                                    <FormControl type="text" name="remitterName" key="txtRemitterName" className="m-t-10"
                                        value={this.state.remitterName}
                                        disabled />
                                </Col>

                                {/* <Col md={6} className="m-t-10">
                                    <label>Date of Birth</label>
                                    <FormControl type="date" name="DOB" key="txtDOB" className="m-t-10"
                                        value={this.state.DOB}
                                        onChange={this.handleFormValidation} disabled />
                                    
                                </Col>*/}

                            </Row>
                        </div>
                        <div className="card-footer">
                            <button className="btn btn-dark" onClick={this.handleCancel}>Cancel</button>
                            <button disabled={this.state.IsDisable} className="btn btn-primary m-l-10" onClick={this.handleSubmit}> {this.state.ButtonText} </button>
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}